/**
 * Sales Service
 *
 * API operations for sales events (POS transactions, terminal payments).
 */

import { apiClient } from '../client'

export interface SaleRow {
  id: string
  organization_id: string
  source: string
  source_id: string | null
  external_id: string | null
  amount: number
  net_amount: number | null
  vat_rate: number | null
  vat_amount: number | null
  fee: number | null
  tip_amount: number | null
  refunded_amount: number | null
  currency: string
  date: string
  timestamp: string | null
  description: string | null
  counterparty: string | null
  payment_type: string | null
  payout_date: string | null
  products: string | null
  account_code: string | null
  status: string | null
  created_at: string
  updated_at: string
}

export interface SalesFilters {
  organizationId: string
  startDate?: string
  endDate?: string
  source?: string
  limit?: number
  offset?: number
}

export class SalesService {
  async list(filters: SalesFilters): Promise<{ sales: SaleRow[]; total: number }> {
    const params = new URLSearchParams({ organizationId: filters.organizationId })
    if (filters.startDate) params.append('startDate', filters.startDate)
    if (filters.endDate) params.append('endDate', filters.endDate)
    if (filters.source) params.append('source', filters.source)
    if (filters.limit) params.append('limit', String(filters.limit))
    if (filters.offset) params.append('offset', String(filters.offset))
    return apiClient.get(`/sales?${params}`)
  }

  async update(id: string, organizationId: string, updates: { accountCode?: string; vatRate?: number }): Promise<void> {
    await apiClient.patch(`/sales/${id}`, { organizationId, ...updates })
  }
}

export const salesService = new SalesService()
